import { FieldLookups } from '../../management360/district/models/program-service.model';

export class ProgramAndServiceDetail {
	FieldName: string;
	FieldValue: string;
	Id: number;
	Sequence: number;
	ProgramServiceField = '';
	FieldType = 0;
	FieldLookupValues: FieldLookups[] = [];
	FieldValueId: number;
	FieldId = 0;
	FieldLength = 0;
	FieldDecimal = 0;
	FieldLengthString = '';
	// NON DTO
	CellBackGroungColor = '';
	OldFieldValue = '';
}
